module.exports = __webpack_public_path__ + "img/360.ac72e345.png";